import React, { Suspense, useEffect } from 'react';

import { Outlet, useLocation } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';

import { ProductDemoBootstrap } from '~modules/product-demo/product-demo-bootstrap';
import { useGetUser } from '~modules/user/api/hooks/use-get-user';

import { AppClarity } from '~components/helpers/app-clarity';
import { DrawerManager } from '~components/shared/drawer/drawer-manager';
import { ConfirmationModal } from '~components/shared/modals/confirmation-modal/confirmation-modal';
import { ModalManager } from '~components/shared/modals/modal-manager';
import { Toasts } from '~components/shared/toasts/toasts';

import { FRONTEND_CONFIG } from '~app/config';

export const BaseRoute = () => {
  const location = useLocation();

  const { data: user } = useGetUser();

  useEffect(() => {
    if (!user?.id) return;

    window.clarity?.('identify', String(user.id), undefined, location.pathname);
    window.clarity?.('set', 'product', 'rentify_app');
    window.clarity?.('set', 'environment', FRONTEND_CONFIG.VITE_NODE_ENV);
  }, [user?.id, location.pathname]);

  return (
    <>
      <AppClarity />
      <ProductDemoBootstrap />

      <Suspense
        fallback={
          <Box display="flex" justifyContent="center" pt={6}>
            <CircularProgress size={28} />
          </Box>
        }
      >
        <Outlet />
      </Suspense>

      <Toasts />
      <ConfirmationModal />
      <ModalManager />
      <DrawerManager />
    </>
  );
};
